import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { PageMenu } from '@/components/page-menu'
import { ApplicantsPage } from '@/modules/user/presentation/pages/applicants/ApplicantsPage'
import { paginationQueryParamsSchema } from '@/shared/schemas/pagination'

export const Route = createFileRoute('/_authenticated/applicants/')({
  component: ApplicantsPage,
  head: () => ({
    meta: [
      {
        title: `Applicants : Search`,
      },
    ],
  }),
  pendingComponent: () => (
    <>
      <PageMenu>
        <div className="grid w-full grid-cols-3">
          <div className="h-9 w-28" />
          <div className="h-9 w-full" />
          <div className="ml-auto h-9 w-28" />
        </div>
      </PageMenu>
    </>
  ),
  validateSearch: paginationQueryParamsSchema.merge(
    z.object({
      search: z.string().optional(),
    }),
  ),
})
